export default __webpack_public_path__ + "static/poster-manufacturing-fbecf68789c9cc44039c2af6093dfd95.jpg";